import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './PaymentSuccess.css';

const PaymentSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      // Короткая загрузка для UX
      setTimeout(() => {
        setLoading(false);
      }, 1000);

      // Автоматически закрыть окно через 4 секунды после загрузки
      setTimeout(() => {
        try {
          window.close();
        } catch (e) {
          // Если не можем закрыть окно, показываем кнопку
          console.log('Cannot close window automatically');
        }
      }, 5000);
    } else {
      setError('Отсутствует ID сессии платежа');
      setLoading(false);
    }
  }, [sessionId]);

  const handleCloseWindow = () => {
    // Закрываем окно или возвращаемся на главную если не можем закрыть
    try {
      window.close();
    } catch (e) {
      window.location.href = '/';
    }
  };

  if (loading) {
    return (
      <div className="payment-result-page">
        <div className="payment-result-container">
          <div className="loading-animation">
            <div className="success-circle">
              <div className="loading-spinner"></div>
            </div>
          </div>
          <h1>Обработка платежа...</h1>
          <p>Пожалуйста, подождите</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="payment-result-page">
        <div className="payment-result-container error">
          <div className="result-icon error-icon">❌</div>
          <h1>Ошибка</h1>
          <p>{error}</p>
          <button className="action-button secondary" onClick={handleCloseWindow}>
            Закрыть окно
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-result-page">
      <div className="payment-result-container success">
        <div className="result-icon success-icon">✅</div>
        <h1>Платёж успешно завершён!</h1>
        <div className="success-details">
          <p>Спасибо за оплату! Ваш доступ активирован.</p>
          <p className="close-instruction">
            Вы можете <strong>закрыть это окно</strong> и продолжить игру.
          </p>
        </div>

        <div className="action-buttons">
          <button className="action-button primary" onClick={handleCloseWindow}>
            Закрыть окно
          </button>
        </div>

        <div className="auto-close-info">
          <p>⏰ Окно автоматически закроется через несколько секунд</p>
          <p>🎮 Игра продолжится в основном окне</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;